require('./angular-sessionstorage')
module.exports = 'ngSessionStorage'
